export class Dokumentation {
    benennung?: string;
    std?: number;
    preis?: number;

    constructor(dokumentationData?: any) {
        Object.assign(this, dokumentationData);
    }
}
